import React from 'react';
import { Link } from 'react-router-dom';
import { Seo } from '../components/Seo';
import { nav } from '../data/site';
export function NotFound() {
  return <>
      <Seo title="Page introuvable | Goelst France S.A.R.L" description="La page demandée n’existe pas ou a été déplacée. Retrouvez les solutions de rails à rideaux Goelst France depuis la navigation principale." path="/404" data-id="element-335" data-mp="w645wtbfe39d" />
      <section className="mx-auto max-w-content px-6 py-24 md:py-32" data-id="element-336" data-mp="1a3982i80qhzc">
        <p className="text-[14px] font-medium text-signal" data-id="element-337" data-mp="1f2lsyxfbxeza">Erreur 404</p>
        <h1 className="mt-4 text-4xl font-semibold tracking-tight text-ink md:text-5xl" data-id="element-338" data-mp="1f0spts3xdcw1">Cette page est introuvable</h1>
        <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-ink-soft" data-id="element-339" data-mp="1nv7905rkt7kf">
          Le lien suivi n’existe pas ou a été modifié. Vous pouvez rejoindre directement l’une des pages du site.
        </p>
        <ul className="mt-8 flex flex-wrap gap-x-6 gap-y-3 text-[16px]" data-id="element-340" data-mp="1xt3lp205wakn">
          {nav.map(item => <li key={item.to} data-id="element-341" data-mp="1nw3ykkev4772">
              <Link to={item.to} className="text-ink underline decoration-line underline-offset-4 hover:text-signal" data-id="element-342" data-mp="1nxf2ck8b5ey6">
                {item.label}
              </Link>
            </li>)}
        </ul>
      </section>
    </>;
}